// extracted by mini-css-extract-plugin
export default {"pill":"DataPill_pill__cS5ZN","cell":"DataPill_cell__N8WY3","edit":"DataPill_edit__JWAd5","textCell":"DataPill_textCell__QaAF9"};